module.exports = __webpack_public_path__ + "static/media/9C633C3F-15C4-48F2-BE75-C2600A69B1C9.3f95d50d.jpeg";